import "./Loader.css"; // optional for styling

const Loader = () => {
  return (
      <div className="loading">
        <div></div>
        <div></div>
      </div>  
  );
}; 

export default Loader; 